



























import Vue from 'vue'
import SimpleLoader from '@/components/atoms/SimpleLoader.vue'
import PageTitle from '@/components/atoms/PageTitle.vue'
import Alert from '@/components/atoms/Alert.vue'
import ListTitle from '@/components/atoms/ListTitle.vue'
import ButtonWrap from '@/components/atoms/ButtonWrap.vue'
import RoundButton from '@/components/atoms/RoundButton.vue'
import ListItem from '@/components/molecules/ListItem.vue'
import { State as UsersState } from '@/store/modules/users'

export default Vue.extend({
  name: 'SettingsMail',
  components: {
    SimpleLoader,
    PageTitle,
    ListTitle,
    ButtonWrap,
    RoundButton,
    ListItem,
    Alert
  },
  data() {
    return {
      thisEmail: '',
      mail: ''
    }
  },
  computed: {
    isPageLoading(): boolean {
      return this.$state.users.isProfileLoading
    },
    profile(): UsersState['profile'] | null {
      return this.$state.users.profile
    }
  },
  methods: {
    onSubmit() {
      this.$validator.validateAll('settingMailForm').then(async result => {
        if (result) {
          this.$store.dispatch('users/postUpdateEmail', {
            email: this.mail
          })
        }
      })
    }
  },
  async mounted() {
    await this.$store.dispatch('users/fetchProfile')
    this.thisEmail = this.profile ? this.profile.email : ''
  }
})
